import { useTranslate, useRecordContext } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { formatDate } from '../../../business-rule/helper/formatDate'

export const DateInDateOutField = ({ nameNode, data }) => {
  const record = useRecordContext()
  const train = data ? data : record?.[nameNode]?.[0]
  const translate = useTranslate()

  if (train) {
    return (
      <>
        <ShowElement
          data={`
            ${translate('ra.field.from')}: ${formatDate(train?.date_in)} | 
            ${translate('ra.field.to')}: ${formatDate(train?.date_out)}
          `}
          label={translate('ra.field.validity')}
        />
      </>
    )
  }
}
